import React from 'react';
import dayjs, { Dayjs } from 'dayjs';
import { DatePicker, Form, InputNumber, Select } from 'antd';

const LABEL_MAP: Record<string, string> = {
  date: 'Em qual data?',
  week: 'Em quantas semanas?'
};

// GERE6-459 — a liberação por data acontece às 00h00 do dia escolhido, então o campo é só de data:
// antes o DatePicker vinha com `showTime` e, se o admin não mexesse na hora, herdava o horário do
// cadastro e o conteúdo só abria no meio do dia.
const DATE_HELP = 'O conteúdo é liberado às 00h00 da data escolhida.';

export type RequirementKind = 'date' | 'week';

export interface SelectRequirementProps {
  kind: RequirementKind;
  defaultValue?: number | Dayjs;
  onSelect: (kind: RequirementKind) => void;
  onInputChange?: (value: number | Dayjs) => void;
}

export const SelectRequirement = ({
  kind,
  defaultValue,
  onSelect,
  onInputChange
}: SelectRequirementProps) => {
  return (
    <div className="flex gap-4">
      <Form.Item label="Liberação por:" initialValue={kind}>
        <Select
          defaultValue="week"
          value={kind}
          className="!w-[120px]"
          onChange={onSelect}
        >
          <Select.Option value="week">Semana(s)</Select.Option>
          <Select.Option value="date">Data</Select.Option>
        </Select>
      </Form.Item>

      <Form.Item
        label={LABEL_MAP[kind]}
        name="duration"
        initialValue={defaultValue}
        extra={kind === 'date' ? DATE_HELP : undefined}
        rules={[{ required: true, message: 'Campo obrigatório' }]}
      >
        {kind === 'date' ? (
          <DatePicker
            format="DD/MM/YYYY"
            onChange={value => onInputChange?.(value || dayjs())}
            defaultValue={defaultValue as Dayjs}
            value={defaultValue as Dayjs}
            allowClear
          />
        ) : (
          <InputNumber
            className="!w-full"
            placeholder={'Digite um nº'}
            onChange={onInputChange}
            value={defaultValue as number}
            defaultValue={defaultValue as number}
          />
        )}
      </Form.Item>
    </div>
  );
};
